/*
  *******************
      注册全局组件
  *******************
*/
import Vue from 'vue'

// 主布局 [header、left-menu]
// import consoleLayout from '~/components/layout/index.vue'
import layout from '~/components/layout'

// 内容布局
import layoutContainer from '~/components/layout-container/index.vue'

// 内容的sidebar
import containerSidebar from '~/components/layout-container/sidebar'
import containerSidebarTitle from '~/components/layout-container/sidebar/sidebar-title.vue'
import containerSidebarContent from '~/components/layout-container/sidebar/sidebar-content.vue'

// 内容主区域
import containerMain from '~/components/layout-container/main'
import containerMainContent from '~/components/layout-container/main/main-content.vue'

// 带下边框的标题
import borderTitle from '~/components/border-title.vue'
// 高72px 的 带操作按钮的header
import handleHeader from '~/components/handleHeader.vue'
// 抽屉组件
import xDrawer from '~/components/drawer/x-drawer.vue'

// 外层布局
Vue.component('layout', layout)

// 内层容器
Vue.component('layoutContainer', layoutContainer)

// 内层容器中的侧边栏
Vue.component('containerSidebar', containerSidebar)
Vue.component('containerSidebarTitle', containerSidebarTitle)
Vue.component('containerSidebarContent', containerSidebarContent)

// 内层容器中的主要区域
Vue.component('containerMain', containerMain)
Vue.component('containerMainContent', containerMainContent)

// 一起用的多的杂项全局组件
Vue.component('borderTitle', borderTitle)
Vue.component('handleHeader', handleHeader)
Vue.component('xDrawer', xDrawer)



// WEBPACK FOOTER //
// ./src/utils/components.js